import React from "react";

const services = [
  {
    title: "Airport Cab Service",
    img: "/images/services/Airport-Cab-Service.jpg",
  },
  {
    title: "Business Travel Cab Service",
    img: "/images/services/Business-Travel-Cab-Service.jpg",
  },
  {
    title: "Corporate Cab Service",
    img: "/images/services/Corporate-Cab-Service.jpg",
  },
  {
    title: "Festival & Event Special Rides",
    img: "/images/services/Festival-&-Event-Special-Rides.jpg",
  },
  { title: "Mumbai Outstation Cabs",
     img: "/images/services/Mumbai-outstation-cab.jpeg", },
  {
    title: "Hill Station Travel Service",
    img: "/images/services/Hill-Station-Travel-Service.jpg",
  },
  {
    title: "Local City Rides",
    img: "/images/services/Local-City-Rides.jpg",
  },
  {
    title: "Luxury Car Rental Service",
    img: "/images/services/Luxury-Car-Rental-Service.jpg",
  },
  {
    title: "One Way Drop Service",
    img: "/images/services/One-Way-Drop-Service.jpg",
  },
  {
    title: "Outstation Cab Service",
    img: "/images/services/Outstation-Cab-Service.jpg",
  },
  {
    title: "Round Trip Taxi Service",
    img: "/images/services/Round-Trip-Taxi-Service.jpg",
  },
  {
    title: "Wedding & Event Transportation",
    img: "/images/services/Wedding-&-Event-Transportation.jpg",
  },
];

const Services = () => {
  return (
    <>

  <div
      className="breadcrumb-wrapper section-padding bg-cover"
      style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
    >
      <div className="container-fluid">
        <div className="page-heading">
          
          <h1 className="wow fadeInUp text-center" data-wow-delay=".5s">
            Services
          </h1>
        </div>
      </div>
    </div>
   


    <section className="services-section">
      <div className="container">

      

        {/* Grid */}
        <div className="row">
          {services.map((item, index) => (
            <div className="col-md-4 col-sm-6 mb-4" key={index}>
              
              <div className="service-card">

                {/* Image */}
                <div className="service-img">
                  <img src={item.img} alt={item.title} />
                </div>

                {/* Content */}
                <div className="service-content">
                  <h4>{item.title}</h4>
                </div>

              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
    
    </>
  );
};

export default Services;